/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-console */
/* eslint-disable global-require */
// eslint-disable-next-line no-use-before-define
import React, { useCallback, useState } from 'react';
import { Image, ImageBackground, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { NavigationContainer } from '@react-navigation/native';
import { LinearGradient } from 'expo-linear-gradient';
import AcquireScreen from './src/screens/AcquireScreen';
import DepositScreen from './src/screens/DepositScreen';
import ActivityScreen from './src/screens/ActivityScreen';
import RedeemScreen from './src/screens/RedeemScreen';
import TwdcComponent from './src/assets/svg/twdc';
import AquireIcon from './src/assets/svg/acquireIcon';
import AquireIconOn from './src/assets/svg/aquireIconOn';
import RedeemIconOn from './src/assets/svg/redeemIconOn';
import RedeemIcon from './src/assets/svg/redeemIcon';
import DepositIcon from './src/assets/svg/depositIcon';
import ActivityIcon from './src/assets/svg/activityIcon';
import DepositIconOn from './src/assets/svg/depositIconOn';
import UserIcon from './src/assets/svg/userIcon';
import PopupMenu from './src/components/PopupMenu';

const styles = StyleSheet.create({
  header: {
    height: 92,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  twdcLogo: {
    marginLeft: 72,
    marginTop: 15,
    marginBottom: 14,
  },
  tabBarContainer: {
    marginTop: 60,
    paddingTop: 0,
    flexDirection: 'row',
    height: 86,
    width: 1328,
    alignSelf: 'center',
    justifyContent: 'space-between',
  },
  tabButton: {
    flexDirection: 'row',
    height: 70,
    width: 320,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    marginBottom: 16,
  },
  tabButtonCurrent: {
    width: 320,
  },
  tabButtonCurrentContainer: {
    flexDirection: 'row',
    width: 320,
    height: 86,
    alignItems: 'center',
    justifyContent: 'center',
  },
  backgroundContainer: {
    backgroundColor: '#efefef',
    height: '100%',
    justifyContent: 'flex-start',
  },
  tabIcon: {
    marginright: 11,
    marginTop: 16,
    marginBottom: 16,
  },
  tabIconCurrent: {
    marginright: 11,
    marginTop: 16,
    marginBottom: 31,
  },
  tabText: {
    fontSize: 26,
    marginLeft: 11,
    marginTop: 16,
    marginBottom: 16,
    color: '#247a9c',
  },
  tabTextCurrent: {
    fontSize: 26,
    marginLeft: 11,
    marginTop: 16,
    marginBottom: 31,
    color: '#fff',
  },
  activityIconOn: {
    width: 33,
    height: 37,
  },
  userButton: {
    height: 39,
    width: 191,
    marginTop: 27,
    marginBottom: 26,
    marginRight: 28,
    backgroundColor: '#fff',
    opacity: 0.8,
    borderRadius: 24.5,
    flexDirection: 'row',
  },
  userIcon: {
    marginLeft: 8,
    marginTop: 5,
    marginBottom: 5,
  },
  userName: {
    marginLeft: 18,
    marginRight: 35,
    marginTop: 8,
    marginBottom: 9,
    height: 22,
    width: 101,
    fontSize: 16,
    fontFamily: 'PingFangSC-Semibold',
    color: '#555559',
  },
});

const Tab = createMaterialTopTabNavigator();

export default React.memo(() => {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [balanceCache, setBalanceCache] = useState(0);

  // @ts-ignore
  const TabBar = ({ navigation, state }) => {
    return (
      <View style={styles.tabBarContainer}>
        {state.index === 0 ? (
          <TouchableOpacity style={styles.tabButtonCurrent}>
            <ImageBackground
              source={{ uri: require('./src/assets/images/tab-highlight.svg') }}
              style={styles.tabButtonCurrentContainer}
            >
              <AquireIconOn style={styles.tabIconCurrent} />
              <Text style={styles.tabTextCurrent}>Acquire</Text>
            </ImageBackground>
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={() => {
              navigation.navigate('Acquire');
            }}
            style={styles.tabButton}
          >
            <AquireIcon style={styles.tabIcon} />
            <Text style={styles.tabText}>Acquire</Text>
          </TouchableOpacity>
        )}
        {state.index === 1 ? (
          <TouchableOpacity style={styles.tabButtonCurrent}>
            <ImageBackground
              source={{ uri: require('./src/assets/images/tab-highlight.svg') }}
              style={styles.tabButtonCurrentContainer}
            >
              <RedeemIconOn style={styles.tabIconCurrent} />
              <Text style={styles.tabTextCurrent}>Redeem</Text>
            </ImageBackground>
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={() => {
              navigation.navigate('Redeem');
            }}
            style={styles.tabButton}
          >
            <RedeemIcon style={styles.tabIcon} />
            <Text style={styles.tabText}>Redeem</Text>
          </TouchableOpacity>
        )}
        {state.index === 2 ? (
          <TouchableOpacity style={styles.tabButtonCurrent}>
            <ImageBackground
              source={{ uri: require('./src/assets/images/tab-highlight.svg') }}
              style={styles.tabButtonCurrentContainer}
            >
              <DepositIconOn style={styles.tabIconCurrent} />
              <Text style={styles.tabTextCurrent}>Deposit</Text>
            </ImageBackground>
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={() => {
              navigation.navigate('Deposit');
            }}
            style={styles.tabButton}
          >
            <DepositIcon style={styles.tabIcon} />
            <Text style={styles.tabText}>Deposit</Text>
          </TouchableOpacity>
        )}
        {state.index === 3 ? (
          <TouchableOpacity style={styles.tabButtonCurrent}>
            <ImageBackground
              source={{ uri: require('./src/assets/images/tab-highlight.svg') }}
              style={styles.tabButtonCurrentContainer}
            >
              <Image
                source={{ uri: require('./src/assets/images/icon-activity.png') }}
                style={[styles.tabIconCurrent, styles.activityIconOn]}
              />
              <Text style={styles.tabTextCurrent}>Activity</Text>
            </ImageBackground>
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={() => {
              navigation.navigate('Activity');
            }}
            style={styles.tabButton}
          >
            <ActivityIcon style={styles.tabIcon} />
            <Text style={styles.tabText}>Activity</Text>
          </TouchableOpacity>
        )}
      </View>
    );
  };

  const handlePressClose = useCallback(() => {
    setMenuVisible(false);
  }, []);

  const handleCache = useCallback((balance: number) => {
    setBalanceCache(balance);
  }, []);

  return (
    <View style={styles.backgroundContainer}>
      <LinearGradient
        style={styles.header}
        colors={['#03ae9d', '#45459b']}
        start={{
          x: 0,
          y: 0,
        }}
        end={{
          x: 1,
          y: 1,
        }}
      >
        <TwdcComponent style={styles.twdcLogo} />
        <TouchableOpacity style={styles.userButton} onPress={() => setMenuVisible(true)}>
          <UserIcon style={styles.userIcon} />
          <Text style={styles.userName}>User Name</Text>
        </TouchableOpacity>
      </LinearGradient>
      <View>
        <NavigationContainer>
          {/* @ts-ignore */}
          <Tab.Navigator tabBar={props => <TabBar {...props} />} swipeEnabled={false}>
            <Tab.Screen name="Acquire" component={AcquireScreen} />
            <Tab.Screen name="Redeem" component={RedeemScreen} />
            <Tab.Screen name="Deposit" component={DepositScreen} />
            <Tab.Screen name="Activity" component={ActivityScreen} />
          </Tab.Navigator>
        </NavigationContainer>
      </View>
      {isMenuVisible ? (
        <PopupMenu handleClosePopup={handlePressClose} balanceCache={balanceCache} handleCache={handleCache} />
      ) : (
        <View />
      )}
    </View>
  );
});
